module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionRscjMobile-2.a31d84a8.png";